import { useState } from 'react';

export const PRIVACY_CONTACT = 'sahith.koripelly@gmail.com';

export function downloadDocument(doc) {
  const text = `${doc.title}\nVersion: ${doc.version}\nPrepared: ${doc.preparedOn}\n\n${doc.sections.map(s => `${s.title}\n${s.paragraphs.join('\n\n')}`).join('\n\n')}\n\nAcknowledgment: ${doc.statement}\nDocument fingerprint: ${doc.hash}\n`;
  const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url; link.download = `Scheduler-${doc.key}-${doc.version}.txt`;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function LegalDocuments({ documents }) {
  return <div className="legal-documents">{documents.map(doc => <details key={`${doc.key}-${doc.version}`} className="legal-document">
    <summary>{doc.title}<span>Version {doc.version}</span></summary>
    <div className="legal-document-body">
      <p className="legal-muted">Prepared {doc.preparedOn} · Version {doc.version}</p>
      <button type="button" className="btn btn-secondary btn-sm" onClick={() => downloadDocument(doc)}>Download a copy</button>
      {doc.sections.map(section => <section key={section.title}><h3>{section.title}</h3>{section.paragraphs.map(p => <p key={p}>{p}</p>)}</section>)}
    </div>
  </details>)}</div>;
}

export function AcceptanceForm({ documents, onAccept, saving }) {
  const [checked, setChecked] = useState({});
  return <form onSubmit={e => { e.preventDefault(); if (documents.every(d => checked[d.hash])) onAccept(documents.map(d => ({ key: d.key, version: d.version, hash: d.hash, accepted: true }))); }}>
    <LegalDocuments documents={documents} />
    <fieldset className="legal-checks" disabled={saving}><legend>Your review</legend>
      {documents.map(doc => <label key={doc.hash}><input type="checkbox" checked={!!checked[doc.hash]} onChange={e => setChecked(c => ({ ...c, [doc.hash]: e.target.checked }))} required /><span>{doc.statement}</span></label>)}
    </fieldset>
    <p className="legal-muted">Privacy acknowledgment confirms receipt and review. It is not blanket consent or a waiver of employment rights.</p>
    <button className="btn btn-primary" type="submit" disabled={saving || !documents.length || !documents.every(d => checked[d.hash])}>{saving ? 'Saving your review…' : 'Agree and continue'}</button>
  </form>;
}

export function AttendanceHelp() {
  return <aside className="legal-help"><strong>Need to clock in or out?</strong><p>Your workplace kiosk is still available. If you cannot use it, tell your manager the actual time worked so it can be recorded. Ask for help if you do not understand or cannot agree to these documents.</p><a href={`mailto:${PRIVACY_CONTACT}`}>Contact the Administrator</a></aside>;
}
